import { AxiosPromise } from "axios";

import request from "@/utils/request";

import { LoginData, LoginResult, UpdatePwdData } from "./types";

/**
 * 登录API
 *
 * @param data {LoginData}
 * @returns
 */
export function tenantPreCheck(tenantCode: string): AxiosPromise {
  return request({
    url: "/biz/public/tenant_id",
    method: "get",
    params: {
      tenantCode,
    },
  });
}

/**
 * 登录API
 *
 * @param data {LoginData}
 * @returns
 */
export function loginApi(data: LoginData): AxiosPromise<LoginResult> {
  return request({
    url: "/uaa/oauth/token",
    headers: {
      isToken: false,
      // saas:saas 编码成base64
      Authorization: "Basic c2FhczpzYWFz",
    },
    method: "post",
    params: {
      ...data,
      scope: "server",
      grant_type: "password",
    },
  });
}

/**
 * 登录API
 *
 * @param data {LoginData}
 * @returns
 */
export function refreshTokenApi(
  data: LoginData,
  refreshToken: string
): AxiosPromise<LoginResult> {
  return request({
    url: "/uaa/oauth/token",
    headers: {
      isToken: false,
      // saas:saas 编码成base64
      Authorization: "Basic c2FhczpzYWFz",
    },
    method: "post",
    params: {
      ...data,
      scope: "server",
      grant_type: "refresh_token",
      refresh_token: refreshToken,
    },
  });
}

/**
 * 修改密码
 *
 * @param data
 * @returns
 */
export function updatePwdApi(
  data: UpdatePwdData,
  accessToken: string
): AxiosPromise<LoginResult> {
  return request({
    url: "/system/user/modifyPwd",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method: "post",
    params: {
      ...data,
    },
  });
}

/**
 * 注销API
 */
export function logoutApi() {
  return request({
    url: "/uaa/token/logout",
    method: "delete",
  });
}

/**
 * 使用Token登出
 */
export function logoutToken(token: string) {
  return request({
    url: "/uaa/token/logout_token",
    method: "delete",
    params: {
      token,
    },
  });
}
